import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";

import { MapTools } from "./map-tools";
import { MapControl, selectors } from "./map-control";
import { NonFieldFeaturePopupActionHandler } from "./non-field-feature-popup-action-handler";
import { Loader, LoaderTypes } from "~/core";

import "./map-container.css";
import {
    BaseLayer,
    FieldBoundaryImportLayer,
    FieldsLayer,
    ImportDataConvexHullLayer,
} from "@ai360/core";

interface MapContainerProps {
    basemap: string;
    isCanvasLoading: boolean;
    isLoading: boolean;
}

interface MapContainerState {
    map: any;
    getFieldsLayer: (layers: Map<string, BaseLayer>) => FieldsLayer;
    getFieldBoundaryImportLayer: (layers: Map<string, BaseLayer>) => FieldBoundaryImportLayer;
    getImportDataConvexHullLayer: (layers: Map<string, BaseLayer>) => ImportDataConvexHullLayer;
}

export class MapContainer extends Component<MapContainerProps, MapContainerState> {
    constructor(props) {
        super(props);
        this.state = {
            map: null,
            getFieldsLayer: null,
            getFieldBoundaryImportLayer: null,
            getImportDataConvexHullLayer: null,
        };
    }

    _setMapRef({ map, getFieldBoundaryImportLayer, getFieldsLayer, getImportDataConvexHullLayer }) {
        this.setState(
            {
                map,
                getFieldBoundaryImportLayer,
                getFieldsLayer,
                getImportDataConvexHullLayer,
            },
            this.forceUpdate
        );
    }

    render() {
        return (
            <div className={classnames("map-container", `${this.props.basemap}-basemap`)}>
                {!(this.props.isLoading || this.props.isCanvasLoading) ? null : (
                    <Loader type={LoaderTypes.BALL_SCALE_MULTIPLE} />
                )}
                {this.state.map == null ? null : (
                    <>
                        <MapTools
                            {...{
                                map: this.state.map,
                                getFieldsLayer: this.state.getFieldsLayer,
                                getFieldBoundaryImportLayer: this.state.getFieldBoundaryImportLayer,
                                getImportDataConvexHullLayer:
                                    this.state.getImportDataConvexHullLayer,
                            }}
                        />
                        <NonFieldFeaturePopupActionHandler map={this.state.map} />
                    </>
                )}
                <MapControl {...{ onSetMap: (e) => this._setMapRef(e) }} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        basemap: selectors.getBasemap(state),
        isLoading: selectors.getIsLoading(state),
        isCanvasLoading: selectors.getIsCanvasLoading(state),
    };
};

export default connect(mapStateToProps)(MapContainer);
